import { MdOutlineWarning } from 'react-icons/md';
import { Tooltip } from '@ds';

type LegWarningsListProps = {
  warnings: string[];
};

export const LegWarningsList = ({ warnings }: LegWarningsListProps) => {
  if (!warnings.length) return null;

  return (
    <Tooltip
      content={
        <div className="flex flex-col gap-1">
          {warnings.map((m) => (
            <span key={m} className="text-s-r">
              {m}
            </span>
          ))}
        </div>
      }
    >
      <div className="text-warning-40">
        <MdOutlineWarning size={16} />
      </div>
    </Tooltip>
  );
};
